import React from 'react'
import { Route } from 'react-router-dom'
import Dashboard from '../../../pages/Organizational/Management/Dashboard/Index'
import Members from '../../../pages/Organizational/Management/Members/Index'
import Structure from '../../../pages/Organizational/Management/Structure/Index'
import Staffs from '../../../pages/Organizational/Management/Staffs/Index'
import Activities from '../../../pages/Organizational/Management/Activities/Index'
import ManageDefaultRoutes from '../../ManageDefaultRoutes'

const ManagementRoutes = (
    <Route path="management/*">
        <Route index element={<ManageDefaultRoutes path={"dashboard"} />} />

        <Route path="dashboard" element={<Dashboard />} />
        <Route path="members" element={<Members />} />
        <Route path="structure" element={<Structure />} />
        <Route path="staffs" element={<Staffs />} />
        <Route path="activites" element={<Activities />} />
    </Route>
)
export default ManagementRoutes